import { Api } from "api";
import { PaymentFilters } from "types/payment";
import { FileDetails } from "types/file";

export const getPayments = async (payload: PaymentFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_payment_approval_requests/`, payload_hash);
  return res.data;
};

export const getPaymentsTable = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_payment_approval_requests_table/`, payload_hash);
  return res.data;
};

export const getPaymentById = async (paymentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/get_payment_approval_requests_by_id/?hash_pw=${hash}&payment_request_id=${paymentId}`);
  return res.data;
};

export const createPaymentRequest = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/create_payment_approval_request/?hash_pw=${hash}`, payload);
  return res.data;
};

export const approvePaymentRequest = async (paymentId: number, approved: boolean, info?: string) => {
  const hash = localStorage.getItem("hash");
  const addInfo = info ? `&additional_info=${info}` : "";
  const url = `/approve_payment_request/?hash_pw=${hash}&payment_request_id=${paymentId}&approval=${approved}${addInfo}`;
  const res = await Api.post(url);
  return res.data;
};

export const deletePayment = async (paymentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/delete_payment_approval_request/${paymentId}?hash_pw=${hash}`);
  return res.data;
};

export const uploadPaymentFiles = async (payment_request_id: number, payload: FormData) => {
  const hash = localStorage.getItem("hash");
  payload.append("hash_pw", hash || "");
  const res = await Api.post(`/upload_payment_files/${payment_request_id}`, payload);
  return res.data;
};

export const getPaymentFileNames = async (paymentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_payment_file_names/${paymentId}?hash_pw=${hash}`);
  return res.data;
};

export const getPaymentFileLink = async (paymentId: number, file: FileDetails) => {
  const hash = localStorage.getItem("hash");
  const payload = {
    ...file,
    hash_pw: hash,
  };
  const url = `download_payment_file/${paymentId}`;
  const res = await Api.post(url, payload, { responseType: "blob" });
  return res;
};

export const getPaymentDetails = async (request_id: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/payment_details/?hash_pw=${hash}&payment_request_id=${request_id}`);
  return res.data;
};

export const getPaymentApprovals = async (request_id: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_payment_approvals_with_positions/?hash_pw=${hash}&payment_request_id=${request_id}`);
  return res.data;
};

export const getCommentsForPayment = async (paymentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_payment_comments_by_id/?hash_pw=${hash}&payment_request_id=${paymentId}`);
  return res.data;
};

export const addCommentToPayment = async (paymentId: number, logs: string) => {
  const hash = localStorage.getItem("hash");
  const url = `/add_comment_to_payment_request/?hash_pw=${hash}&payment_request_id=${paymentId}&logs=${logs}`;
  const res = await Api.post(url);
  return res.data;
};
